<template>
  <div class="bq-tab" :class="[`bq-tab-${layout}`, { mobile: isMobile }]">
    <ul class="bq-tab-wrap" :class="isFixed">
      <li
        class="bq-tab-item"
        v-for="(item, index) in tabs"
        :key="index"
        :class="{ active: active === index }"
        @click="handleClick(index, item)"
      >
        <img
          :class="item.class"
          :src="item.icon"
          :alt="item.title"
          v-if="isMobile"
        />
        <span v-else>{{ item.title }}</span>
      </li>
    </ul>

    <ul class="bq-tab-content" :class="isFixed">
      <li
        v-for="(item, index) in tabs"
        :key="item.title"
        v-show="index === active"
      >
        <bq-article
          :title="item.title"
          :tags="item.tags"
          :content="item.content"
          v-if="item.content"
        />
      </li>
    </ul>
  </div>
</template>

<script>
import BqArticle from '@/components/Article';
// import { isWirelessDevice } from '../../utils/utils.js';

export default {
  name: 'BQTab',
  components: {
    BqArticle,
  },

  props: {
    layout: {
      type: String,
      default: 'vertical', // 目前只编写 vertical
    },
    fixedHeight: {
      // 吸顶高度
      type: Number,
      default: 770,
    },
    tabs: {
      type: Array,
      required: true,
    },
    isTitle: {
      type: Boolean,
      default: true,
    },
    defaultActive: {
      type: Number,
      default: 0,
    },
    clickCallback: Function,
  },

  data() {
    return {
      isMobile: false,
      active: this.defaultActive,
      isFixed: '',
    };
  },

  mounted() {
    // window.addEventListener('scroll', this.windowScroll);
  },

  created() {
    // this.isMobile = isWirelessDevice();
  },

  methods: {
    // windowScroll() {
    //   let scrollTop =
    //     window.pageYOffset ||
    //     document.documentElement.scrollTop ||
    //     document.body.scrollTop;
    //   if (this.layout === 'vertical' && scrollTop > this.fixedHeight) {
    //     this.isFixed = 'fixed';
    //   } else {
    //     this.isFixed = '';
    //   }
    // },
    handleClick(index, item) {
      this.active = index;

      if (this.clickCallback) {
        this.clickCallback(item);
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import './index.less';
</style>
